const config = {
    "SERVER_URL": "https://app.shorakae.com",
    "SERVER_PORT": "8443",
    "APP_PATH": "mylibshare",
    "LOCALE": "ar",
    "VERSION": "1.8.0"
}

export default config